/**
 * prd2 Day 17 — remote vehicles render slightly in the past so we always have
 * two samples to interpolate between (Gabriel Gambetta-style buffer).
 */
export const NET_INTERP = {
  /** How far behind "now" we render remote entities (ms). */
  INTERP_DELAY_MS: 90,
  /** Drop samples older than this behind the render cursor (ms). */
  MAX_BUFFER_MS: 900,
  /** Hard cap per entity to bound memory. */
  MAX_SNAPSHOTS: 32,
  /** Forward extrapolation cap when no newer snapshot yet (s). */
  MAX_EXTRAPOLATE_S: 0.08,
  /** Backward extrapolation when render time is before first sample (s). */
  MAX_BACK_EXTRAPOLATE_S: 0.05,
} as const;
